<template>
  <div v-if="$store.getters.getMobilePhoneActive">
    <v-flex xs12 class="mx-auto max-width-big">
      <v-container grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-card class="elevation-0 transparent">
              <v-layout justify-left>
                <v-card
                  class="left-in elevation-0 ml-4"
                >
                  <v-card-text>
                    <p class="fontSize" :style="getFontProperty()">{{$translate('WELCOME_MESSAGE_TITLE')}}</p>
                    <p
                      class="fontSize"
                      :style="getFontProperty()"
                    >{{$translate('REGISTER_PAGE_TEXT').replace(/accountName/g, $store.getters.getAccountInfo.AccountName)}}</p>
                  </v-card-text>
                </v-card>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 md6>
            <v-card class="elevation-0 transparent">
              <v-card-text>
                <v-form ref="registerForm" v-model="valid" lazy-validation>
                  <v-flex class="emailAd" xs1>{{$translate('EMAIL')}}</v-flex>
                  <v-flex xs12>
                    <v-text-field
                      outline
                      autocomplete="email"
                      placeholder="Example: JohnDoe@mail.com"
                      color="primary"
                      :style="getFontProperty()"
                      v-model="form.userEmail"
                      :rules="validateEmail"
                      required="required"
                    ></v-text-field>
                  </v-flex>

                  <v-layout class="checkboxLayout mb-5">
                    <v-flex xs1>
                      <v-checkbox color="primary" v-model="checkboxAgree" class="checkbox"></v-checkbox>
                    </v-flex>
                    <v-flex xs11 class="mt-1">
                      <p class="mt-1">
                        {{$translate('REGISTER_CHECKBOX')}}
                        <!-- <router-link to="https://www.thedrivingforce.nl/privacy-statement/" class="link">{{$translate('REGISTER_PRIVACY_STATEMENT')}}</router-link> -->
                        <a
                          @click="goToPrivacyStatement()"
                          target="_blank"
                          class="link"
                        >{{$translate('REGISTER_PRIVACY_STATEMENT')}}</a>
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-btn
                    round
                    :loading="loadingRegistration"
                    @click="registerUser"
                    class="ml-0"
                    color="primary"
                  >{{$translate('NEXT')}}</v-btn>
                  <p style="text-align:center">
                    <br>
                  </p>
                  <h3>{{this.errorMsg}}</h3>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-snackbar
      color="primary mt-5"
      :auto-height="true"
      :timeout="timeout"
      :bottom="true"
      :middle="true"
      v-model="snackbar"
    >
      {{ text }}
      <v-btn flat color="pink" @click.native="snackbar = false">{{$translate('CLOSE')}}</v-btn>
    </v-snackbar>
  </div>
  <div v-else>
    <v-container class="registerContainer">
      <v-flex xs10 class="mx-auto containerBackground max-width-big">
        <v-container grid-list-xl>
          <v-flex></v-flex>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card class="elevation-0 transparent">
                <v-layout justify-left>
                  <v-card
                    class="left-in elevation-0 ml-4"
                  >
                    <v-card-text>
                      <p class="fontSize" :style="getFontProperty()">{{$translate('WELCOME_MESSAGE_TITLE')}}</p>
                      <p
                        v-if="$store.getters.getClickedOnPasspoortButton"
                        class="fontSize"
                        :style="getFontProperty()"
                      >{{$translate('REGISTER_PAGE_TEXT').replace(/accountName/g, $store.getters.getAccountInfo.AccountName)}}</p>
                      <p
                        v-else
                        class="fontSize"
                        :style="getFontProperty()"
                      >{{$translate('REGISTER_PAGE_WELCOME')}}</p>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
              <v-card class="elevation-0 transparent">
                <v-card-text>
                  <v-form ref="registerForm" v-model="valid" lazy-validation>
                    <v-flex class="emailAd" xs1>{{$translate('EMAIL')}}</v-flex>
                    <v-flex xs12>
                      <v-text-field
                        outline
                        autocomplete="email"
                        placeholder="Example: JohnDoe@mail.com"
                        color="primary"
                        :style="getFontProperty()"
                        v-model="form.userEmail"
                        :rules="validateEmail"
                        required="required"
                      ></v-text-field>
                    </v-flex>

                    <v-layout class="checkboxLayout mb-5">
                      <v-flex xs1>
                        <v-checkbox color="primary" v-model="checkboxAgree" class="checkbox"></v-checkbox>
                      </v-flex>
                      <v-flex xs11 class="mt-1">
                        <p class="mt-1">
                          {{$translate('REGISTER_CHECKBOX')}}
                          <!-- <router-link to="https://www.thedrivingforce.nl/privacy-statement/" class="link">{{$translate('REGISTER_PRIVACY_STATEMENT')}}</router-link> -->
                          <a
                            @click="goToPrivacyStatement()"
                            target="_blank"
                            class="link"
                          >{{$translate('REGISTER_PRIVACY_STATEMENT')}}</a>
                        </p>
                      </v-flex>
                    </v-layout>
                    <v-card-text id="infoSmall" class="px-0 changeFont text-md-left text-xs-left">
                      <h3>
                        <v-icon large>info</v-icon>
                        {{$translate('REGISTER_INFO')}}
                      </h3>
                      <p>
                        <b>{{$translate('REGISTER_PHONE')}}</b>
                        {{$translate('REGISTER_PHONE_TEXT')}}
                      </p>
                      <p>
                        <b>{{$translate('REGISTER_ZIPCODE')}}</b>
                        {{$translate('REGISTER_ZIPCODE_TEXT')}}
                      </p>
                      <p>
                        <b>{{$translate('REGISTER_LICENSE')}}</b>
                        {{$translate('REGISTER_LICENSE_TEXT')}}
                      </p>
                    </v-card-text>
                    <v-btn
                      round
                      :loading="loadingRegistration"
                      @click="registerUser"
                      class="ml-0"
                      color="primary"
                    >{{$translate('NEXT')}}</v-btn>
                    <p style="text-align:center">
                      <br>
                    </p>
                    <h3>{{this.errorMsg}}</h3>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-container>
    <v-snackbar
      color="primary mt-5"
      :auto-height="true"
      :timeout="timeout"
      :bottom="true"
      :middle="true"
      v-model="snackbar"
    >
      {{ text }}
      <v-btn flat color="pink" @click.native="snackbar = false">{{$translate('CLOSE')}}</v-btn>
    </v-snackbar>
  </div>
</template>


<script>
  import { mapGetters } from "vuex";
  import appConfig from "../../../config/app_config";
  import TagsObject from "../../objects/TagsObject.js";
  import UserObject from "../../objects/UserObject.js";
  import BaseObject from "../../objects/BaseObject";
  import { countries } from "../../shared/countries.js";
  import { emailRules } from "../../shared/validations_rules.js";
  import { ui_helpers } from "../../shared/ui_helpers";

  export default {
    mixins: [ui_helpers],
    computed: {
      likesAllTags() {
        return this.selectedTags.length === this.tags.length;
      },
      likesSomeTags() {
        return this.selectedTags.length > 0 && !this.likesAllTags;
      },
      icon() {
        if (this.likesAllTags) return "check_box";
        if (this.likesSomeTags) return "indertiminate_checkbox";
        return "check_box_outline_blank";
      }
    },
    data: () => ({
      e4: false,
      loadingRegistration: false,
      request: {
        requestAction: {
          Request: "getChilds",
          ObjectId: "DSSRequestHandler"
        }
      },
      a1: null,
      states: countries,
      customFilter(item, queryText, itemText) {
        const hasValue = val => (val != null ? val : "");
        const text = hasValue(item.name);
        const query = hasValue(queryText);
        return (
          text
            .toString()
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) > -1
        );
      },
      uniqueId: "test",
      errorMsg: "",
      retVal: "",
      checkboxAgree: true,
      checkboxInfo: false,
      enviromentName: "",
      visit: {
        myself: false,
        partner: false,
        friends: false,
        kids: false,
        school: false
      },
      form: UserObject._objectDefinition(),
      tags: [],
      user: null,
      selectedTags: [],
      checkBoxTags: [],
      loadingSaveTags: false,
      valid: true,
      snackbar: false,
      name: "",
      text: "",
      timeout: 6000,
      status: "",
      email: "",
      validateEmail: emailRules,
      passwordRules: [
        v => !!v || "Required.",
        v => v.length >= 8 || "Min 8 characters"
      ],
      errorMessage: [],
      internalUserType: "user"
    }),
    mounted() {

      if (this.$route.params.type !== undefined) {

        this.internalUserType = this.$route.params.type;
      }
    },
    created() {
      this.$store.dispatch("setStepId", 1);
    },
    methods: {
      toggle() {
        this.$nextTick(() => {
          if (this.likesAllTags) {
            this.selectedTags = [];
          } else {
            for (let t in this.tags) {
              let index = this.selectedTags.indexOf(this.tags[t].TagId);
              if (index == -1) {
                this.selectedTags.push(this.tags[t].TagId);
              }
            }
          }
        });
      },
      registerUser() {
        // this.getTagId()
        if (this.$refs.registerForm.validate()) {
          if (this.checkboxAgree == false) {
            window.EventBus.fire(
              "activateSnackBar",
              "Please agree with the privacy statement!"
            );
          } else {
            this.loadingRegistration = true;
            this.errorMsg = "";
            this.user = new UserObject(
              this.uniqueId,
              this.form.userEmail,
              this.internalUserType,
              "",
              this.$store.getters.getGoToAfterLoginOrRegister
            );
            this.user.userRegister(
              response => {
                console.log("response for userRegister", response)
                this.uniqueId = response.data.UserId;
                this.loggedSuccess(response);
                this.loadingRegistration = false;
              },
              error => {
                console.log("error for userRegister", error)
                this.loadingRegistration = false;
              }
            );
          }
        } else
          window.EventBus.fire(
            "activateSnackBar",
            "Something is missing in your form"
          );
      },
      registerUnsuccessfull(error) {
        if (error["errorMsg"] == "EMAIL_EXISTS") {
          // this.errorMsg = "Your account was not created. Something went wrong"
          this.errorMsg = "Your Email Account is already registered.";
        } else {
          if (error["errorMsg"] == "REGISTRATION_CODE_INVALID") {
            // this.errorMsg = "Your account was not created. Something went wrong"
            this.errorMsg = "The VIP Code is Invalid.";
          } else {
            this.errorMsg =
              "We’re very sorry, but an error occurred. Please try again. If the problem continues to occur, please contact the Customer Service Center at helpdesk@trafficlink.nl or call +31 297 51 44 55. Thank you for your cooperation.";
          }
        }
      },
      goTo(page, params = "component") {

        // Generic function to let the user move to other component
        this.$router.push({
          name: page,
          params: params
        });
      },
      loggedSuccess(response) {
        this.goTo("AccountRegisterSuccess",  {uniqueId: this.uniqueId});
      },
      getTagId() {
        const arrayLength = this.tags.length;
        let i = arrayLength;
        this.form.userTags = [];
        while (i--) {
          if (this.checkBoxTags[i] == true) {
            this.form.userTags.push(this.tags[i].TagId);
          }
        }
      },
      clear() {
        this.$refs.form.reset();
      },
      goToPrivacyStatement(){
        this.$router.push({
          name: 'PrivacyStatement',
          params: 'component',
        });
      },
    }
  };
</script>

<style scoped>
  .greyBorder {
    border: 2px solid #c0c0c0 !important;
  }

  .emailAd {
    margin-bottom: -1.8em !important;
  }

  .borderLeft {
    margin-bottom: 1.5em;
    border-left: 2px solid #c0c0c0;
  }

  @media screen and (max-width: 960px) {
    .borderLeft {
      border-left: 0px;
    }
  }

  .lindaLogo {
    height: 25em;
    margin-left: -5.5em;
  }

  .checkbox {
    margin: 0px !important;
  }

  .link {
    color: black;
    text-decoration: underline;
  }

  .fontSize {
    font-size: 18px;
  }

  .checkboxLayout {
    margin-left: 0.1em !important;
    margin-top: -2em !important;
    height: 40px !important;
  }

  .topBorder {
    border-top: 2px solid #c0c0c0;
  }

  .lindaText {
    max-height: 17em;
    margin-left: -2.5em !important;
    margin: 15px;
    border-radius: 30px;
    max-width: 21em;
  }

  .fontSize {
    font-size: 18px;
  }

  .tri-right.left-in:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left: -25px;
    right: auto;
    top: 30px;
    bottom: auto;
    border: 13px solid;
    border-color: #f2f2f2 #f2f2f2 transparent transparent;
  }

  #infoSmall {
    display: none;
  }
  .registerContainer {
    width:auto;
    height: 90vh;
  }
</style>
